<app-create-pend-modal
  [visible]="visible && hasNormalChases"
  (visibleChange)="visible = $event"
  (onUpdate)="onUpdate.emit()"
  (saving)="saving.emit()"
  (savingFailed)="savingFailed.emit()"
  [chaseIds]="chaseIds"
  [clinical]="clinical"
  [onlyPendPC140Allowed]="onlyPendPC140Allowed"
  [hasClinicalNonClinicalChases]="hasClinicalNonClinicalChases"
  [pageType]="pageType"
  [selectedChasesStatus]="selectedChasesStatus">
</app-create-pend-modal>

<app-edit-pend-modal
  [visible]="visible && hasPendChases && isCurrentSelectedPendCodes"
  (visibleChange)="visible = $event"
  (onUpdate)="onUpdate.emit()"
  (saving)="saving.emit()"
  (savingFailed)="savingFailed.emit()"
  [chasePendIds]="chasePendIds"
  [chaseIds]="chaseIds"
  
  [chases]="chases"
  [clinical]="clinical"
  [hasClinicalNonClinicalChases]="hasClinicalNonClinicalChases">
</app-edit-pend-modal>
